import RemoteServices from '~/constants/RemoteServices';
import {buildUrl} from '~/utils/url';

export const defaultImgixParams = {dpr: 1.2, auto: 'format', nrs: 0};

export function imageUrl(imagePath, useImgix, options = null) {
  const host = useImgix
    ? RemoteServices.productImagesDynamic
    : RemoteServices.productImages;

  let params = null;

  if (useImgix) {
    params = {...defaultImgixParams, ...options};
  }

  return buildUrl(`${host}${imagePath}`, params);
}
